export enum RecordSource {
  MANUAL = 'MANUAL',
  FILE_IMPORT = 'FILE_IMPORT',
  SYS_SYNC = 'SYS_SYNC',
}

export const RecordSourceMap = {
  [RecordSource.MANUAL]: '手动录入',
  [RecordSource.FILE_IMPORT]: '文件导入',
  [RecordSource.SYS_SYNC]: '系统同步',
};

export const RecordSourceOptions = [
  { value: RecordSource.MANUAL, label: RecordSourceMap[RecordSource.MANUAL] },
  {
    value: RecordSource.FILE_IMPORT,
    label: RecordSourceMap[RecordSource.FILE_IMPORT],
  },
  {
    value: RecordSource.SYS_SYNC,
    label: RecordSourceMap[RecordSource.SYS_SYNC],
  },
];
